export const colors = {
    error: '#FCE9E9',
    warn: '#FEF7E9',
    success: '#E6F3E6',
    info: '#F9F9F9',
    none: '#ffffff'
};

export const colorVariants = {
    green: 'bg-green-700',
    red: 'bg-red-700',
    blue: 'bg-blue-700',
    gray: 'bg-gray-500'
};

export const hoverColorVariants = {
    green: 'bg-green-900',
    red: 'bg-red-900',
    blue: 'bg-blue-900'
};
